var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-setting-me"},[_c('HeaderMenu',{attrs:{"title":_vm.title,"routeBackName":_vm.routeBackName}}),_c('BaseHeaderHistoryListDisplay',{on:{"change-type-search":_vm.changeTypeSearch}}),_c('div',{staticClass:"list-menu list-history"},[_vm._l((_vm.userSearchHistory),function(search){return _c('div',{key:search.id + 'a'},[(
          search.pin == 1 &&
            (_vm.searchType == 'all' || _vm.searchType == search.type)
        )?_c('BaseHistorySearchRowItem',{attrs:{"search":search}}):_vm._e()],1)}),_vm._l((_vm.userSearchHistory),function(search,index){return _c('div',{key:search.id},[(
          index == 0 ||
            search.historyDate.getDate() !==
              _vm.userSearchHistory[index - 1].historyDate.getDate() ||
            search.historyDate.getFullYear() !==
              _vm.userSearchHistory[index - 1].historyDate.getFullYear() ||
            search.historyDate.getMonth() !==
              _vm.userSearchHistory[index - 1].historyDate.getMonth()
        )?_c('baseHeaderHistoryDate',{staticClass:"title",attrs:{"historyDate":search.historyDate}}):_vm._e(),(
          search.pin == 0 &&
            (_vm.searchType == 'all' || _vm.searchType == search.type)
        )?_c('BaseHistorySearchRowItem',{attrs:{"search":search}}):_vm._e()],1)})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }